import { useEffect, useRef, useState } from "react";

type AsyncEffect<T> = () => Promise<T>;

export const useAsyncEffect = <T = unknown>(asyncFn: AsyncEffect<T>, depsArray = [] as any[]) => {
  const abortedRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Nullable<unknown>>(null);
  const [data, setData] = useState<Nullable<T>>(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        abortedRef.current = false;

        const data = await asyncFn();
        if (abortedRef.current) {
          return;
        }

        setData(data);
      } catch (e) {
        if (abortedRef.current) {
          return;
        }
        setError(e);
        setData(null);
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      abortedRef.current = true;
    };
  }, depsArray);

  return {
    loading,
    data,
    error
  };
};
